module.exports = {
  auth_api_client_url: "https://auth2.api.eo-heimat.de/",
  auth_api_client_id: "273b039b-e34f-4d23-86f7-ef95dff43a03",
  auth_api_client_secret: "OnnOdHelyeFreir5Vikleitt",

  eo_maps_client_url: "https://maps.api.eo-heimat.de",
  maps_api_key: "FLyGFoGY1HEbIsVFNyKMbDW1eZNL2V8e3lGVAkWA",

  poi_api_client_url: "https://poi3.api.eo-heimat.de/",

  kis_api_client_url: "https://kis.api.eo-heimat.de/",

  booking_api_client_url: "https://booking.api.eo-heimat.de/",

  maps_api_client_url: "https://maps.api.eo-heimat.de/",

  file_client_url: "https://file.api.eo-heimat.de/",
  file_client_token:
    "1hG90F7eSF6HePAlq5MwJbpeZTDAZbtWVX3AG8p8rpAZVG3B5pSbdqbCQ7t9vsNQWfRabrp8C3LTdbVADH2OiMrLnZR3mgkfw7Sc5mNskCQjrlqmCNa",

  assistent_api_client_url: "https://anzeigenassistent.api.eberl-online.net/",

  news_api_client_url: "https://news.api.eo-heimat.de/",

  locations_api_client_url: "https://locations.api.eo-heimat.de/",

  events_api_client_url: "https://events2.api.eo-heimat.de/",

  poi_widget_api_url: "https://eo-poi-widget.api.eo-heimat.de/",

  pois_widget_api_url_v2: "https://pois-widget2.api.eo-heimat.de/",
  pois_widget_api_url: "https://eo-pois-widget.api.eberl-online.net/",
  kis_widget_api_url: "https://kis-widget.api.eo-heimat.de/",
  kis_defect_widget_api_url: "https://kis-defect-widget.api.eo-heimat.de/",
  news_widget_api_url: "https://news-widget.api.eo-heimat.de/",
  events_widget_api_url: "https://events-widget.api.eberl-online.net/",
  news_issues_widget_api_url: "https://news-issues-widget.api.eo-heimat.de/",
  events_widget_api_url_v2: "https://events-widget2.api.eo-heimat.de/",
  last_minute_widget_api_url: "https://lastminute-widget.api.eo-heimat.de/",
  events_report_widget_api_url:
    "https://events-create-widget.api.eo-heimat.de/",
  news_report_widget_api_url: "https://news-create-widget.api.eo-heimat.de/",
  ad_manager_ad_zone_widget_api_url: "https://ad-zone-widget.api.eo-heimat.de/",
  prompts_api_client_url: "https://prompt.api.eo-heimat.de/",
  ad_manager_api_client_url: "https://admanager.api.eo-heimat.de/",
  form_builder_api_client_url: "https://forms.api.eo-heimat.de/",
  forms_widget_base_url: "https://forms-widget.api.eo-heimat.de/"
};
